import { render, staticRenderFns } from "./ImageTextContentType.vue?vue&type=template&id=42c9d69c&scoped=true"
import script from "./ImageTextContentType.vue?vue&type=script&lang=js"
export * from "./ImageTextContentType.vue?vue&type=script&lang=js"
import style0 from "./ImageTextContentType.vue?vue&type=style&index=0&id=42c9d69c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c9d69c",
  null
  
)

export default component.exports